import ActiveEventsList from './ActiveEventsList';

export default ActiveEventsList;
